var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStorageUsedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 3.5C23.8638 3.5 26.2044 3.96558 28.3883 4.87017C30.5722 5.77475 32.5565 7.10062 34.2279 8.77208C35.8994 10.4435 37.2252 12.4278 38.1298 14.6117C39.0344 16.7956 39.5 19.1362 39.5 21.5C39.5 23.8638 39.0344 26.2044 38.1298 28.3883C37.2252 30.5722 35.8994 32.5565 34.2279 34.2279C32.5565 35.8994 30.5722 37.2252 28.3883 38.1298C26.2044 39.0344 23.8638 39.5 21.5 39.5C19.1362 39.5 16.7956 39.0344 14.6117 38.1298C12.4278 37.2252 10.4435 35.8994 8.77207 34.2279C7.10062 32.5565 5.77475 30.5722 4.87017 28.3883C3.96558 26.2044 3.5 23.8638 3.5 21.5C3.5 19.1362 3.96559 16.7955 4.87017 14.6117C5.77476 12.4278 7.10063 10.4435 8.77209 8.77207C10.4435 7.10062 12.4278 5.77475 14.6117 4.87016C16.7956 3.96558 19.1362 3.5 21.5 3.5L21.5 3.5Z",
    stroke: "#5454FF",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8056 37.7726C10.1093 36.0248 7.11811 33.0706 5.32445 29.3963C3.53079 25.722 3.04152 21.5465 3.93717 17.5571C4.83281 13.5676 7.06001 10.002 10.2522 7.44701C13.4443 4.89204 17.4113 3.5 21.5 3.5",
    stroke: "#D9D9D9",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorageUsedIcon);
export default __webpack_public_path__ + "static/media/storage-used-icon.81747959983365a080b7194b0ef4a420.svg";
export { ForwardRef as ReactComponent };